import { BrowserObjectModel } from '../browser-object-model';
import { Injectable } from '../dependency-injection/decorators';

@Injectable()
export class TitleProvider {
  private static selectors = [
    'meta[name="citation_title" i]',
    'meta[name="DC.title" i]',
    'meta[name="og:title" i]',
    'meta[property="og:title" i]',
    'meta[name="twitter:title" i]',
    'meta[name="title" i]',
    'title',
  ];

  public constructor (private readonly browserObjectModel: BrowserObjectModel) {
  }

  public provide (): string | null {
    for (const selector of TitleProvider.selectors) {
      const element = this.browserObjectModel.getDocument().querySelector(selector);

      if (!element) {
        continue;
      }

      const content = element.getAttribute('content') ?? element.textContent;

      if (content) {
        return content;
      }
    }

    return null;
  }
}
